exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group[data-v-e1b49b08] {\n  margin-top: 0;\n}\ntd[data-v-e1b49b08] {\n  vertical-align: middle;\n}", ""]);

// exports
